<template>
    <div class="marg">
     <h1>You're invited to</h1>
        <div class="img_logo">
<img src="/logo.svg" alt="iMeUsWe" class="download-logo" />
</div>

    
       
        <p>Please install the app before clicking on the invite link</p>
    <div v-if="activeLink">
       
        <a :href="activeLink" class="set wrapper"> <button class="blue-button footer"><span class="buttonText">{{ buttonText }}</span></button></a>
    </div>
    </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Quicksand&display=swap');
* {
    font-family: 'Quicksand', sans-serif;
}
.set{
  text-decoration: none;
}
.img_logo {
    margin-bottom: 7vh;
}
.download-logo {
    width: 100%;
    max-width: 367px;
    height: auto;
}
h1 {
 margin-bottom: 7vh;
  font-size: 30px;
font-weight: 600;
line-height: 32px;
letter-spacing: 0em;
}
p {
    
    font-size: 22px;
font-weight: 600;
line-height: 26px;
letter-spacing: 0em;
}
.wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
}
.blue-button {
  
      width: 70%;
      background-color: #3473DC;
    color: white;
      padding: 10px 20px;
      font-size: 18px;
      font-weight: 100;
      border: none;
      border-radius: 7px;
      cursor: pointer;
    }
.buttonText{
  font-weight: 600;
  line-height: 1.5;
}    
.footer {
 position: fixed;
 bottom: 5vh;
display: block;
 
}
.marg{
  padding: 15px;
}
    
</style>



<script>
export default {
name: 'DownloadApp',
  data() {
    return {
      buttonText: "Download",
        osFound:null,
        activeLink: null
    };
  },
  mounted() {
    this.getOS()
    const url = new URL(window.location.href);
    const refVal = url.search;
    const pathname = url.pathname;
    const searchParams = new URLSearchParams(url.search);
    const pathParam = searchParams.get('path');
    
    console.log(window.innerWidth > 600, refVal.includes('ref'));
    
    if (window.innerWidth > 600) {
      let webUrl = null;
      
      if (refVal.includes('ref')) {
        webUrl = `https://web.imeuswe.in/${refVal}`;
      }
      else if (pathname === '/Home') {
        webUrl = 'https://web.imeuswe.in/home/';
      }
      else if (pathname === '/Trees') {
        webUrl = 'https://web.imeuswe.in/tree/';
      }
      else if (pathname === '/Stories') {
        webUrl = 'https://web.imeuswe.in/lifestory/';
      }
      else if (pathname === '/CommunitiesScreenTab') {
        webUrl = 'https://web.imeuswe.in/home/';
      }
      else if (pathname === '/Profile') {
        webUrl = 'https://web.imeuswe.in/profile/';
      }
      else if (pathname === '/ImeusweSearch') {
        webUrl = 'https://web.imeuswe.in/imeusweSearch/imeusweRecord/';
      }
      else if (pathname === '/Login' || pathname === '/SignUp') {
        webUrl = 'https://web.imeuswe.in/home/';
      }
      else if (pathname.startsWith('/CommunityDetails/')) {
        webUrl = 'https://web.imeuswe.in/home/';
      }
      else if (pathParam) {
        const astrologyPaths = {
          'astrohome': 'home',
          'horoscope': 'home',
          'reports': 'home',
          'matchmaking': 'home',
          'panchang': 'home',
          'consultation': 'home',
          'wallethistory': 'home'
        };
        const webPath = astrologyPaths[pathParam.toLowerCase()] || 'home';
        webUrl = `https://web.imeuswe.in/${webPath}/`;
      }
      
      if (webUrl) {
        window.location.assign(webUrl);
        history.replaceState({}, '', `${url.origin}`);
      }
    }
  },
  methods:{
    getOS() {
  let userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      // macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      // windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod']
      
   if (iosPlatforms.indexOf(platform) !== -1) {
    this.osFound = 'iOS';
    this.activeLink = "itms-apps://itunes.apple.com/app/id1634383924"
  } else if (/Android/.test(userAgent)) {
    this.osFound = 'Android';
    this.activeLink = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.imeuswe.app"
  } else {
    console.error('no os')
  }
}
  }
  
};
</script>